import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function footer() {

    const footerElements = document.querySelectorAll('[data-footer-parallax]');
    if (footerElements.length === 0) return;

    footerElements.forEach(el => {
        
        const inner = el.querySelector('[data-footer-parallax-inner]');
        const dark  = el.querySelector('[data-footer-parallax-dark]');
        const cta_fixed = document.querySelector('.cta_fixed');

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: el,
                start: 'top bottom',     // el footer entra por la parte inferior del viewport
                end: 'bottom bottom',    // el footer termina cuando su fondo llega al fondo del viewport
                scrub: true,
                invalidateOnRefresh: true,
                onEnter: () => {
                    if (cta_fixed) {
                        gsap.to(cta_fixed, { opacity: 0, y: 20, duration: 0.4, ease: 'power2.in', onComplete: () => { cta_fixed.style.display = 'none'; } });
                    }
                },
                onLeaveBack: () => {
                    if (cta_fixed) {
                        cta_fixed.style.display = 'flex';
                        gsap.fromTo(cta_fixed, { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 0.4, ease: 'power2.out' });
                    }
                },
                // markers: true,
            }
        });

        if (inner) {
            tl.fromTo(inner,
                { yPercent: -25 },
                { yPercent: 0, ease: 'linear' }
            );
        }

        if (dark) {
            tl.fromTo(dark,
                { opacity: 0.5 },
                { opacity: 1, ease: 'linear' },
                '<'
            );
        }
    });

}

export default footer;